import { toast } from "react-toastify";
import * as actionTypes from "./actionTypes";
import authService from "../../api/authService";
import history from "../../..";
import { getRefreshToken } from "../../config/auth/credentialConfiguration";

const loginUser = (currentUser) => {
  return { type: actionTypes.LOGIN_USER, payload: { currentUser } };
};

const loginAuthentication = (authentication) => {
  return { type: actionTypes.AUTHENTICATION_V2_USER, payload: { authentication } };
};

export const setCurrentAuthentication = (currentAuthentication) => {
  return { type: actionTypes.AUTHENTICATION_V2_USER, payload: { currentAuthentication } };
}

export const setCurrentUser = (currentUser) => {
  return { type: actionTypes.CURRENT_USER, payload: { currentUser } };
};

const signOutUser = () => {
  return { type: actionTypes.LOGOUT_USER };
};

export const login = (credentials) => async (dispatch) => {
  try {
    const response = await authService.loginV2(credentials);
    dispatch(loginAuthentication({
      ...response.data,
      tipoDocumento: credentials.tipoDocumento,
      numeroDocumento: credentials.numeroDocumento
    }));
    history.push("/login/validacion");
  } catch (error) {
    throw error;
  }
};

export const loginVerification = (req) => async (dispatch) => {
  try {
    const response = await authService.loginVerificationV2(req);
    dispatch(loginUser(response.data));
    history.push("/inicio");
  } catch (error) {
    throw error;
  }
};

export const refreshToken = () => async (dispatch) => {
  try {
    dispatch(loadingRefreshToken(true));
    const response = await authService.refreshToken({
      refreshToken: getRefreshToken(),
    });
    dispatch(loginUser(response.data));
    dispatch(loadingRefreshToken(false));
  } catch (error) {
    dispatch(loadingRefreshToken(false));
    throw error;
  }
};

const loadingRefreshToken = (loadingRefreshToken) => {
  return {
    type: actionTypes.LOADING_REFRESH_TOKEN,
    payload: { loadingRefreshToken },
  };
};

export const getUser = () => async (dispatch) => {
  try {
    const response = await authService.currentUser();
    dispatch(setCurrentUser(response.data));
  } catch (error) {
    toast.error(error);
  }
};

export const logout = () => (dispatch) => {
  try {
    authService.logout().then(() => {
      dispatch(signOutUser());
      history.push("/");
    }).catch((err)=>{
      console.log("err ===============> ",err);
    });
  } catch (error) {
    toast.error(error);
  }
};

const showDialogUserIddleReducer = (showDialogUserIddle) => {
  return {
    type: actionTypes.SHOW_DIALOG_USER_IDDLE,
    payload: { showDialogUserIddle },
  };
};

export const setShowDialogUserIddle = (showDialogUserIddle) => async (
  dispatch
) => {
  dispatch(showDialogUserIddleReducer(showDialogUserIddle));
};
